import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import CreateCommissionForm from '../CreateCommissionForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'

export default function CreateCommissionListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`สร้างกิจกรรมคอมมิชชั่น`}
					description="สร้างกิจกรรมคอมมิชชั่น"
				/>
				<NavigateBackButton />
			</div>
			<Separator />
			<CreateCommissionForm />
		</div>
	)
}
